// extracted by mini-css-extract-plugin
export default {"field":"SidebarFilters_field__WpPgx","fieldTitle":"SidebarFilters_fieldTitle__6TnNR","separator":"SidebarFilters_separator__JrWXA","badge":"SidebarFilters_badge__Y8Pwd"};